import type { IconData } from '@stacksjs/iconify-core'

export const userStickerSquare: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M8.063 44.445c-2.439-.202-4.306-2.07-4.508-4.508C3.288 36.723 3 31.514 3 24s.288-12.723.555-15.937c.202-2.439 2.07-4.306 4.508-4.508C11.277 3.288 16.486 3 24 3s12.723.288 15.937.555c2.439.202 4.306 2.07 4.508 4.508C44.712 11.277 45 16.486 45 24c0 2.927.07 5.754 0 8L32 45c-2.246.07-5.073 0-8 0c-7.514 0-12.723-.288-15.937-.555\"/><path d=\"M32 29c-4.418 5.333-11.582 5.333-16 0m0-12v2m16-2v2m13 13c-3.449.106-6.101.292-8.026.474c-2.426.229-4.27 2.074-4.5 4.5c-.182 1.924-.368 4.577-.474 8.026\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userStickerSquare
